/**
 * Kill-switch helper for the ngsw removal (CRM-633).
 * Unregisters any existing service worker and clears its caches so clients
 * stop serving the old cached bundle and pick up the new API URL build.
 *
 * Returns true when a service worker was actually removed, so the caller can
 * decide to hard-reload the tab (the old worker keeps controlling this load
 * until a navigation happens).
 */
export async function unregisterServiceWorkers(
  serviceWorker: ServiceWorkerContainer | undefined,
  cacheStorage: CacheStorage | undefined,
): Promise<boolean> {
  if (!serviceWorker?.getRegistrations) {
    return false;
  }

  const registrations = await serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  if (cacheStorage) {
    const keys = await cacheStorage.keys();
    // Only touch Angular ngsw caches, other caches on this origin are not ours.
    await Promise.all(
      keys.filter((key) => key.includes('ngsw')).map((key) => cacheStorage.delete(key)),
    );
  }

  return registrations.length > 0;
}
